import Button from "./Button";
import React from "react";

const CardCreateNewButton = ({clickHandler, text= 'Add New'}) => {
  return(
    <Button
      text={text}
      variant={"btn_black"}
      onClickHandler={clickHandler}
    />
  );
}

export default CardCreateNewButton